export default {
    "name": "MergeVendors",
    "kind": "HoudiniMutation",
    "hash": "60688e91aed1ca3ec6f16b96a65bce74b20f09671b6aafb376ac5fdc0f4a0524",

    "raw": `mutation MergeVendors($input: MergeVendorsInput!) {
  mergeVendors(input: $input) {
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "mergeVendors": {
                "type": "Vendor",
                "keyRaw": "mergeVendors(input: $input)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "MergeVendorsInput"
        },

        "types": {
            "MergeVendorsOptionsInput": {
                "addresses": "Boolean",
                "attachments": "Boolean",
                "catalogs": "Boolean",
                "messages": "Boolean",
                "options": "Boolean",
                "purchaseOrders": "Boolean"
            },

            "MergeVendorsInput": {
                "mergeOptions": "MergeVendorsOptionsInput",
                "sourceVendorIds": "ID",
                "targetVendorId": "ID"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=5e6d2c8c80c1d7820fb36806a1056bf546d603eb689098fee9c28b4639e299eb";